import React, { useEffect, useState } from 'react'
import { RadioGroup } from '../../atoms'

import styles from './_.module.css'

interface Props {
  // sort options to be rendered
  options: SortOptionType
  // default filter values when the component mounts
  defaultValue?: SortValueType
  // send the filter values onSubmit
  applyFilters: (filters: SortValueType) => void
  // action when close icon is pressed
  onClose?: () => void
}

export const SortMenu: React.FC<Props> = ({
  options,
  defaultValue,
  applyFilters,
  onClose
}) => {
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    if (defaultValue) {
      const option = Object.values(options).find(
        option =>
          option.order === defaultValue?.sort_order &&
          option.sort_by === defaultValue?.sort_by
      )
      setValue(option?.value ?? '')
    }
  }, [defaultValue, options])

  const handleResetFilter = (): void => {
    setValue('')
    applyFilters({
      sort_order: null,
      sort_by: null
    })
    onClose && onClose()
  }

  const handleSubmit = (): void => {
    const sortValue = options[value]
    applyFilters({
      sort_order: sortValue?.order,
      sort_by: sortValue?.sort_by
    })
    onClose && onClose()
  }

  return (
    <div className={styles.container}>
      <section className={styles.listContainer}>
        <RadioGroup
          className={styles.radioGroup}
          options={Object.values(options)}
          onChange={(e): void => setValue(e.target.value)}
          value={value}
        />
      </section>

      <footer>
        <button onClick={handleResetFilter} className={styles.button}>
          Clear
        </button>
        <button
          onClick={handleSubmit}
          className={`${styles.button} ${styles.primary}`}
        >
          Confirm
        </button>
      </footer>
    </div>
  )
}
